module.exports = __webpack_public_path__ + "daa817584853c08443c71da0faaf8f95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-31.png
// module id = 1510
// module chunks = 0